export default __webpack_public_path__ + "static/media/NationalWebLF-Semibold.8c35d832.ttf";